// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"Store_PageHolder__2aszH","fixPage":"Store_fixPage__23WLw","loading2Test":"Store_loading2Test__owJKm"};